"use client";

import { Bitcoin, Landmark, type LucideIcon } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { DESKTOP_NAV } from "@/lib/navigation";
import { BrandMark } from "./brand-mark";

const ICONS: Record<string, LucideIcon> = {
  crypto: Bitcoin,
  macro: Landmark
};

export function Sidebar() {
  const { t } = useI18n();
  const pathname = window.location.pathname;
  return (
    <aside data-primary-sidebar className="sticky top-0 hidden h-dvh w-60 shrink-0 border-r border-[var(--hc-border)] bg-[var(--hc-surface-1)] px-4 py-5 lg:block">
      <div className="mb-8 flex items-center gap-3">
        <BrandMark variant="compact" priority />
        <div className="min-w-0 leading-tight">
          <p className="truncate text-sm font-semibold text-[var(--hc-text)]">{t("app.brand")}</p>
          <p className="mt-0.5 text-[11px] font-medium uppercase tracking-[0.12em] text-[var(--hc-muted)]">{t("app.brand.sub")}</p>
        </div>
      </div>
      <nav className="space-y-1" aria-label="Primary navigation">
        {DESKTOP_NAV.map((item) => {
          const Icon = ICONS[item.icon];
          const current = item.href === "/" ? pathname === "/" : pathname.startsWith(item.href);
          return (
            <a
              key={item.id}
              href={item.href}
              aria-current={current ? "page" : undefined}
              className={`group flex min-h-11 items-center gap-3 rounded-md border-l-2 px-3 py-2 text-sm font-medium transition-colors ${
                current
                  ? "border-[var(--hc-blue)] bg-[var(--hc-blue-soft)] text-[var(--hc-text)]"
                  : "border-transparent text-[var(--hc-muted)] hover:bg-[var(--hc-surface-2)] hover:text-[var(--hc-text)]"
              }`}
            >
              <Icon size={18} strokeWidth={1.7} aria-hidden="true" />
              {t(item.labelKey)}
            </a>
          );
        })}
      </nav>
    </aside>
  );
}
